// myfrontend/src/components/EditForm.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import '../static/form.css';
import '../static/modals.scss';
import '../static/SignaturePad.css';

const EditForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // ✅ We assume location.state has the pet + owner data (passed when navigating here)
  const { pet, owner } = location.state || {};

  // Owner Info
  const [name, setName] = useState(owner?.name || '');
  const [phoneMobile, setPhoneMobile] = useState(owner?.phone_mobile || '');
  const [email, setEmail] = useState(owner?.email || '');
  const [postcode, setPostcode] = useState(owner?.postcode || '');
  const [address, setAddress] = useState(owner?.address || '');
  const [points, setPoints] = useState(owner?.points || '');
  const [numberOfVisit, setNumberOfVisit] = useState(owner?.numberofvisit || '');
  const [note, setNote] = useState(owner?.note || '');

  // Pet Info
  const [petName, setPetName] = useState(pet?.name || '');
  const [breed, setBreed] = useState(pet?.breed || '');
  const [catdog, setCatdog] = useState(pet?.catdog || '');
  const [gender, setGender] = useState(pet?.gender || '');
  const [age, setAge] = useState(pet?.age || '');
  const [behaviour, setBehaviour] = useState(pet?.behaviour || '');
  const [allergies, setAllergies] = useState(pet?.allergies || '');
  const [vaccinated, setVaccinated] = useState(pet?.vaccinated === 'Yes');
  const [neutered, setNeutered] = useState(pet?.neutered === 'Yes');
  const [groomingHistory, setGroomingHistory] = useState(pet?.grooming_history || '');
  const [socialMediaConsent, setSocialMediaConsent] = useState(pet?.social_media_consent === 'Yes');

  const handleUpdate = async (e) => {
    e.preventDefault();

    try {
      // ✅ Update Owner
      const ownerFormData = new FormData();
      ownerFormData.append('name', name);
      ownerFormData.append('phone_mobile', phoneMobile);
      ownerFormData.append('email', email);
      ownerFormData.append('postcode', postcode);
      ownerFormData.append('address', address);
      ownerFormData.append('points', points);
      ownerFormData.append('numberofvisit', numberOfVisit);
      ownerFormData.append('note', note);

      await axios.put(`/update-owner/${owner.id}/`, ownerFormData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      // ✅ Update Pet
      const petFormData = new FormData();
      petFormData.append('name', petName);
      petFormData.append('breed', breed);
      petFormData.append('catdog', catdog);
      petFormData.append('phone', phoneMobile);
      petFormData.append('gender', gender);
      petFormData.append('age', age);
      petFormData.append('behaviour', behaviour);
      petFormData.append('allergies', allergies);
      petFormData.append('vaccinated', vaccinated ? 'Yes' : 'No');
      petFormData.append('neutered', neutered ? 'Yes' : 'No');
      petFormData.append('grooming_history', groomingHistory);
      petFormData.append('social_media_consent', socialMediaConsent ? 'Yes' : 'No');
      petFormData.append('owner', owner.id);

      await axios.put(`/update-pet/${pet.id}/`, petFormData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      alert('Pet & Owner updated successfully!');
      navigate('/'); // 👈 Redirect somewhere after update
    } catch (error) {
      console.error('Update failed:', error.response?.data || error.message);
      alert('Failed to update data.');
    }
  };

  return (
    <section className="contact-wrap" style={{ backgroundColor: '#FFFFFF' }}>
      <form onSubmit={handleUpdate} className="contact-form" encType="multipart/form-data">
        <h3>Edit Owner Info</h3>

        <label>Name:</label>
        <input type="text" value={name} onChange={(e) => setName(e.target.value)} />

        <label>Phone:</label>
        <input type="text" value={phoneMobile} onChange={(e) => setPhoneMobile(e.target.value)} />

        <label>Email:</label>
        <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} />

        <label>Postcode:</label>
        <input type="text" value={postcode} onChange={(e) => setPostcode(e.target.value)} />

        <label>Address:</label>
        <textarea value={address} onChange={(e) => setAddress(e.target.value)} />

        <h3>Edit Pet Info</h3>
        <label>Pet Name:</label>
        <input type="text" value={petName} onChange={(e) => setPetName(e.target.value)} />

        <label>Breed:</label>
        <input type="text" value={breed} onChange={(e) => setBreed(e.target.value)} />

        <label>Type (Cat/Dog):</label>
        <select value={catdog} onChange={(e) => setCatdog(e.target.value)}>
          <option value="">Select</option>
          <option value="Cat">Cat</option>
          <option value="Dog">Dog</option>
        </select>

        <label>Gender:</label>
        <select value={gender} onChange={(e) => setGender(e.target.value)}>
          <option value="">Select</option>
          <option value="Male">Male</option>
          <option value="Female">Female</option>
        </select>

        <label>Age:</label>
        <input type="number" value={age} onChange={(e) => setAge(e.target.value)} />

        <label>Behaviour:</label>
        <input type="text" value={behaviour} onChange={(e) => setBehaviour(e.target.value)} />

        <label>Allergies:</label>
        <textarea value={allergies} onChange={(e) => setAllergies(e.target.value)} />

        <label>
          Vaccinated:
          <input type="checkbox" checked={vaccinated} onChange={(e) => setVaccinated(e.target.checked)} />
        </label>

        <label>
          Neutered:
          <input type="checkbox" checked={neutered} onChange={(e) => setNeutered(e.target.checked)} />
        </label>

        <label>Grooming History:</label>
        <textarea value={groomingHistory} onChange={(e) => setGroomingHistory(e.target.value)} />

        <label>
          Social Media Consent:
          <input type="checkbox" checked={socialMediaConsent} onChange={(e) => setSocialMediaConsent(e.target.checked)} />
        </label>

        <button type="submit" className="square-button">Update Info</button>
      </form>
    </section>
  );
};

export default EditForm;
